var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParkOutlineVolumeNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V21C8.5 21 5.8995 16.42 5.8995 16.42H3C2.73478 16.42 2.48043 16.3146 2.29289 16.1271C2.10536 15.9396 2 15.6852 2 15.42V8.505C2 8.23978 2.10536 7.98543 2.29289 7.79789C2.48043 7.61036 2.73478 7.505 3 7.505H5.8995C5.8995 7.505 8.5 3 12 3Z",
    stroke: "#2D91FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5C16.3124 7.77957 16.5946 8.0911 16.842 8.4295C17.5977 9.46632 18.0033 10.717 18 12C18 13.327 17.577 14.5535 16.861 15.545C16.609 15.8933 16.3204 16.2134 16 16.5",
    stroke: "#2D91FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1179 20.5913C20.0419 18.8463 21.9999 15.6508 21.9999 11.9983C21.9999 8.40228 20.1019 5.25028 17.2534 3.48828",
    stroke: "#2D91FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineVolumeNotice);
export default __webpack_public_path__ + "static/media/icon-park-outline_volume-notice.158859ce1bff11eeed3c4e43cd455a8d.svg";
export { ForwardRef as ReactComponent };